if (!customElements.get("pickup-availability")) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if (this.hasAttribute("available")) {
        const template = this.querySelector("template");
        this.errorHtml = template?.content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }
    }

    fetchAvailability(variantId) {
      let baseUrl = this.dataset.baseUrl;
      if (!baseUrl.endsWith("/")) baseUrl += "/";

      fetch(`${baseUrl}variants/${variantId}/?section_id=pickup-availability`)
        .then((res) => res.text())
        .then((html) => {
          const parsed = new DOMParser().parseFromString(html, "text/html");
          const section = parsed.querySelector(".shopify-section");
          this.renderPreview(section);
        })
        .catch((error) => {
          const refreshButton = this.querySelector("button");
          if (refreshButton) {
            refreshButton.removeEventListener("click", this.onClickRefreshList);
          }
          this.renderError();
        });
    }

    onClickRefreshList() {
      this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
      this.innerHTML = "";
      this.appendChild(this.errorHtml);
      const retryButton = this.querySelector("button");
      if (retryButton) {
        retryButton.addEventListener("click", this.onClickRefreshList);
      }
    }

    renderPreview(section) {
      const drawer = document.querySelector("#Drawer-Pickup-Availability");
      if (drawer) drawer.remove();

      const preview = section.querySelector("pickup-availability-preview");
      if (!preview) {
        this.innerHTML = "";
        this.removeAttribute("available");
        return;
      }

      this.innerHTML = preview.outerHTML;
      this.setAttribute("available", "");

      const drawerElement = section.querySelector("#Drawer-Pickup-Availability");
      if (drawerElement) document.body.appendChild(drawerElement);

      const button = this.querySelector("button");
      if (button) {
        button.addEventListener("click", () => {
          const drawer = document.querySelector("#Drawer-Pickup-Availability");
          if (!drawer) return;
          drawer.openDrawer();

          // ✅ Red warning logic for unavailable locations
          setTimeout(() => {
            const items = drawer.querySelectorAll('.m-pickup-availability__item');
            items.forEach(item => {
              const timeEl = item.querySelector('.m-pickup-availability__item--time');
              if (timeEl && timeEl.textContent.trim() === '') {
                timeEl.innerHTML = '<span class="pickup-unavailable">❌ Pickup not available at this store</span>';
              }
            });
          }, 200);
        });
      }
    }
  }

  customElements.define("pickup-availability", PickupAvailability);
}

if (!customElements.get("pickup-availability-drawer")) {
  class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
      super();
      this.drawerWrapper = this.querySelector(".m-drawer__wrapper");
      this.drawerContent = this.querySelector(".m-drawer__content");
      this.drawerClose = this.querySelector(".m-drawer__close");

      this.drawerClose.addEventListener("click", (e) => {
        e.preventDefault();
        this.closeDrawer();
      });

      document.body.addEventListener("click", (e) => {
        if (e.target.classList.contains("m-drawer__wrapper")) {
          this.closeDrawer();
        }
      });
    }

    openDrawer() {
      if (window.innerWidth < 770) {
        document.documentElement.classList.add("prevent-scroll");
        this.drawerWrapper.classList.add("mobile");
      }

      this.drawerWrapper.classList.remove("m:hidden");

      requestAnimationFrame(() => {
        this.drawerWrapper.style.setProperty("--m-bg-opacity", "0.5");
        this.drawerContent.style.setProperty("--m-translate-x", "0");
      });
    }

    closeDrawer() {
      this.drawerWrapper.style.setProperty("--m-bg-opacity", "0");
      this.drawerContent.style.setProperty("--m-translate-x", "100%");

      setTimeout(() => {
        this.drawerWrapper.classList.add("m:hidden");
        this.drawerWrapper.classList.remove("mobile");
        document.documentElement.classList.remove("prevent-scroll");
      }, 300);
    }
  }

  customElements.define("pickup-availability-drawer", PickupAvailabilityDrawer);
}
